import { G as push, Q as push_element, T as pop_element, O as attr, K as pop, F as FILENAME } from "../../../chunks/index.js";
_page[FILENAME] = "src/routes/login/+page.svelte";
function _page($$payload, $$props) {
  push(_page);
  let email = "user@osport.ee";
  let password = "";
  $$payload.out.push(`<div class="flex min-h-screen items-center justify-center p-4">`);
  push_element($$payload, "div", 17, 0);
  $$payload.out.push(`<div class="w-full max-w-sm space-y-4 rounded border bg-white p-6">`);
  push_element($$payload, "div", 18, 1);
  $$payload.out.push(`<h1 class="text-xl font-semibold">`);
  push_element($$payload, "h1", 19, 2);
  $$payload.out.push(`Logi sisse</h1>`);
  pop_element();
  $$payload.out.push(` `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <label class="block">`);
  push_element($$payload, "label", 21, 2);
  $$payload.out.push(`<span class="text-sm">`);
  push_element($$payload, "span", 22, 3);
  $$payload.out.push(`E-post</span>`);
  pop_element();
  $$payload.out.push(` <input type="email" class="w-full rounded border px-3 py-2"${attr("value", email)}/>`);
  push_element($$payload, "input", 23, 3);
  pop_element();
  $$payload.out.push(`</label>`);
  pop_element();
  $$payload.out.push(` <label class="block">`);
  push_element($$payload, "label", 25, 2);
  $$payload.out.push(`<span class="text-sm">`);
  push_element($$payload, "span", 26, 3);
  $$payload.out.push(`Parool</span>`);
  pop_element();
  $$payload.out.push(` <input type="password" class="w-full rounded border px-3 py-2"${attr("value", password)}/>`);
  push_element($$payload, "input", 27, 3);
  pop_element();
  $$payload.out.push(`</label>`);
  pop_element();
  $$payload.out.push(` <button class="w-full rounded bg-blue-600 px-3 py-2 text-white">`);
  push_element($$payload, "button", 29, 2);
  $$payload.out.push(`Sisene</button>`);
  pop_element();
  $$payload.out.push(`</div>`);
  pop_element();
  $$payload.out.push(`</div>`);
  pop_element();
  pop();
}
_page.render = function() {
  throw new Error("Component.render(...) is no longer valid in Svelte 5. See https://svelte.dev/docs/svelte/v5-migration-guide#Components-are-no-longer-classes for more information");
};
export {
  _page as default
};
